export const SEARCH_DEBOUNCE_MS = 350;
export const KLIPY_TRENDING_PER_PAGE = 24;
export const KLIPY_SEARCH_PER_PAGE = 20;
export const KLIPY_SEARCH_MAX_GIFS = 120;
